var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('img',{attrs:{"src":require("../assets/logo-pepz.svg"),"alt":"logo pepz"}}),_c('h2',[_vm._v("Estimation des aides locales")])])}]

export { render, staticRenderFns }